import { NoteType } from 'types';
import { baseQuery } from '../baseQuery';

export const getTicketNoteTypes = async () => {
  const { data } = await baseQuery('ticket/note-types');

  return data as NoteType[];
};
